import { Component } from '@angular/core';

@Component({
  selector: 'digital-platform-root',
  templateUrl: './app.component.html',
})
export class AppComponent {}
